module.exports = __webpack_public_path__ + "img/x4.3d6ed682.jpg";